import { makeStyles } from '@material-ui/core';
import { komaxColors } from '../../theme/komax';

// The "x" of the Komax wordmark: white left strokes, red right stroke.
const X_LEFT = [
  'M2464.65 1403 2468 1397.7 2463.6 1391 2456 1391 2464.5 1403 2464.65 1403Z',
  'M2464.5 1404 2464.5 1404 2456 1417 2463.6 1417 2468 1409.89 2464.5 1404Z',
];
const X_RED =
  'M2482 1391 2474.3 1391 2466 1403.82 2474.3 1417 2482 1417 2472.89 1403.82 2482 1391Z';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2455 1390 28 28"
      role="img"
      aria-label="Komax"
    >
      {X_LEFT.map(d => (
        <path key={d} d={d} fill="#FFFFFF" fillRule="evenodd" />
      ))}
      <path d={X_RED} fill={komaxColors.red} fillRule="evenodd" />
    </svg>
  );
};

export default LogoIcon;
